/**
 * rb-atc-feedback — phản hồi TỨC THÌ cho nút "Add to cart".
 *
 * ── VÌ SAO ────────────────────────────────────────────────────────────────────────────────────
 * Đo bằng CDP ngày 14/08/2026 trên roambark.com (Slow 4G, 390×844): bấm Add to cart thì
 * ngăn kéo giỏ mở lúc **1360–1438 ms**, và thay đổi nhìn thấy đầu tiên trên chính cái nút là
 * **1906 ms**. Trong hơn một giây rưỡi đó nút không đổi chữ, không quay, không khoá — trên
 * điện thoại đó là lời mời bấm lần hai, và lần hai thì thêm một món nữa vào giỏ.
 *
 * Theme Horizon có sẵn `data-added` nhưng nó chỉ chạy animation checkmark 800 ms và được đặt
 * TRƯỚC khi fetch, nên nó không nói gì về việc request đã xong hay chưa. `product-form.js`
 * gọi `fetch(Theme.routes.cart_add_url)` mà không disable nút, không đặt `aria-busy`.
 *
 * ── CÁCH LÀM ──────────────────────────────────────────────────────────────────────────────────
 * Nghe `click` ở pha CAPTURE để chạy trước handler của theme, rồi CHỈ đặt thuộc tính
 * `aria-busy="true"`. `rb-premium.css` đã có sẵn luật cho thuộc tính đó
 * (`opacity:.7; pointer-events:none`), nên nút vừa mờ đi vừa tự chặn cú bấm thứ hai —
 * không cần `disabled`, không cần chặn sự kiện.
 *
 * ⚠️ TUYỆT ĐỐI KHÔNG gọi `preventDefault()` / `stopPropagation()`. Dự án đã dính đúng lỗi đó
 * một lần: `StitchChromeBridge` gọi `preventDefault()` ở pha capture và nuốt luôn nút ADD TO
 * CART thật — ngăn kéo mở ra rỗng, không lỗi, không cảnh báo. Ở đây ta chỉ ĐỌC sự kiện và
 * ĐẶT thuộc tính, không bao giờ can thiệp vào đường đi của nó.
 *
 * ⚠️ Cũng không đổi chữ trong nút. `product-form.js` dùng `morph()` để vẽ lại nút khi đổi biến
 * thể; sửa text bằng tay là đánh nhau với morph. Thuộc tính `aria-busy` thì morph giữ nguyên.
 *
 * Gỡ trạng thái khi: giỏ báo đã cập nhật (`cart:update`), hoặc hết 8 giây (phòng khi mạng chết —
 * nút kẹt mờ vĩnh viễn còn tệ hơn nút im lặng).
 */

const CHON_NUT = '.add-to-cart-button, button[name="add"], .sticky-add-to-cart__button';
const HET_HAN_MS = 8000;

/** @type {Set<HTMLElement>} */
const dangBan = new Set();

/** @param {HTMLElement} nut */
function xong(nut) {
  if (!dangBan.has(nut)) return;
  dangBan.delete(nut);
  nut.removeAttribute('aria-busy');
  nut.removeAttribute('data-rb-busy');
}

function xongHet() {
  for (const nut of [...dangBan]) xong(nut);
}

document.addEventListener(
  'click',
  (su) => {
    const dich = /** @type {HTMLElement | null} */ (su.target);
    const nut = dich?.closest?.(CHON_NUT);
    if (!(nut instanceof HTMLElement)) return;
    if (nut.hasAttribute('disabled')) return;
    if (dangBan.has(nut)) return;

    // Chỉ đặt thuộc tính. Không đụng vào sự kiện — xem chú thích đầu file.
    dangBan.add(nut);
    nut.setAttribute('aria-busy', 'true');
    nut.setAttribute('data-rb-busy', 'true');

    setTimeout(() => xong(nut), HET_HAN_MS);
  },
  { capture: true, passive: true }
);

// `CartAddEvent.eventName === 'cart:update'` trong assets/events.js của Horizon.
for (const ten of ['cart:update', 'cart:error']) {
  document.addEventListener(ten, xongHet);
}

// Ngăn kéo mở ra cũng là bằng chứng việc đã xong — bắt cả đường này phòng khi sự kiện đổi tên.
document.addEventListener('dialog:open', xongHet);
